import { render, staticRenderFns } from "./prop-info.vue?vue&type=template&id=4a54dcbe&scoped=true&"
import script from "./prop-info.vue?vue&type=script&lang=js&"
export * from "./prop-info.vue?vue&type=script&lang=js&"
import style0 from "./prop-info.vue?vue&type=style&index=0&id=4a54dcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54dcbe",
  null
  
)

export default component.exports